export const generateRandomBaseTenNumber = (): number =>
  Math.floor(Math.random() * 10);
